module.exports = __webpack_public_path__ + "static/tw-trade-table-b4323c8d77d3856812bbfec7fe3ca0d7.jpg";